const parseQueryParamsFromRelativeUrlPath = (relativeUrlPath: string) => {
  const queryParamsString = relativeUrlPath.substring(relativeUrlPath.indexOf('?'));
  return new URLSearchParams(queryParamsString);
};

export default parseQueryParamsFromRelativeUrlPath;
